'use client';
import { ProductDocument } from 'models/product';
import { onSnapshot } from 'firebase/firestore';
import { useMemo, useState, useEffect } from 'react';
import { getProductsByIdQuery } from '@util/firestore/products';
import { useAuth } from 'context/AuthContext';

// Stable reference to prevent infinite loops
const EMPTY_ID_FALLBACK = [''];

const useRealTimeProducts = (ids: string[]) => {
  const { userDoc } = useAuth();
  const [realTimeProducts, setProducts] = useState<ProductDocument[]>([]);
  const productsQuery = useMemo(
    () => getProductsByIdQuery(ids.length ? ids : EMPTY_ID_FALLBACK),
    [ids]
  );
  useEffect(() => {
    if (!userDoc) return;
    // Early return for empty arrays to avoid unnecessary listener setup
    if (!ids.length) {
      setProducts([]);
      return;
    }
    const unsubscribe = onSnapshot(productsQuery, (snapshot) => {
      const realTimeData = snapshot.docs.map((doc) => doc.data());
      setProducts(realTimeData);
    });
    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productsQuery, userDoc, ids.length]);

  return {
    realTimeProducts,
  };
};

export default useRealTimeProducts;
